import type { PathType } from './types';
import { getPath } from './types';

export const miscPaths: { [key: string]: PathType } = {
  // Corporate Operation & Asset Management
  corporateOperation: getPath('/coporate-opertaion', ['sidebar.home', 'v2.coporateOpertaion.index']),
  handoverTicket: getPath('/coporate-opertaion/asset-management/handover-ticket', [
    'v2.sidebar.home',
    'v2.assetManagement.index',
    'v2.assetManagement.handoverTicket'
  ]),
  myHandoverTicket: getPath('/coporate-opertaion/asset-management/handover-ticket/my-ticket', [
    'v2.sidebar.home',
    'v2.assetManagement.index',
    'v2.assetManagement.handoverTicket',
    'Phiếu của tôi'
  ]),
  handoverTicketApproval: getPath('/coporate-opertaion/asset-management/handover-ticket/confirm', [
    'v2.sidebar.home',
    'v2.assetManagement.index',
    'v2.assetManagement.handoverTicket',
    'v2.sidebar.confirm'
  ]),
  handoverTicketAdd: getPath('/coporate-opertaion/asset-management/handover-ticket/add', [
    'v2.sidebar.home',
    'v2.assetManagement.index',
    'v2.assetManagement.handoverTicket',
    'action.add'
  ]),
  handoverTicketEdit: getPath('/coporate-opertaion/asset-management/handover-ticket/edit', [
    'v2.sidebar.home',
    'v2.assetManagement.index',
    'v2.assetManagement.handoverTicket',
    'action.edit'
  ]),
  // Topic
  topic: getPath('/topic', ['sidebar.home', 'v2.topic.index']),

  // Report
  report: getPath('/report', ['sidebar.home', 'v2.report.index']),
  reportLeaveTicket: getPath('/report/leave-ticket', ['sidebar.home', 'v2.report.index', 'v2.report.leaveTicket']),
  reportOvertimeTicket: getPath('/report/overtime-ticket', [
    'sidebar.home',
    'v2.report.index',
    'v2.report.overtimeTicket'
  ]),
  reportBiometricData: getPath('/report/biometric-data', [
    'sidebar.home',
    'v2.report.index',
    'v2.report.biometricData'
  ]),
  reportPNL04: getPath('/report/pln4', ['sidebar.home', 'v2.report.index', 'pln4']),
  reportBusinessTripTicket: getPath('/report/business-trip-ticket', [
    'sidebar.home',
    'v2.report.index',
    'v2.report.businessTripTicket'
  ]),
  reportDailyInventoryJournal: getPath('/report/daily-inventory-journal', [
    'sidebar.home',
    'v2.report.index',
    'v2.report.dailyInventoryJournal'
  ]),

  // Report
  proposal: getPath('/proposal', ['sidebar.home', 'v2.proposal.index']),
  proposalAdd: getPath('/proposal/add', ['sidebar.home', 'v2.proposal.index', 'action.add']),
  proposalEdit: getPath('/proposal/edit', ['sidebar.home', 'v2.proposal.index', 'action.edit']),
  proposalDetail: getPath('/proposal/detail', ['sidebar.home', 'v2.proposal.index', 'action.review']),

  // Item Master Data
  itemMasterData: getPath('/item-master-data', ['sidebar.home', 'v2.itemMasterData.index']),
  itemMasterDataAdd: getPath('/item-master-data/add', ['sidebar.home', 'v2.itemMasterData.index', 'action.add']),
  itemMasterDataEdit: getPath('/item-master-data/edit', ['sidebar.home', 'v2.itemMasterData.index', 'action.edit']),
  itemType: getPath('/item-type', ['sidebar.home', 'v2.itemMasterData.index', 'v2.itemMasterData.itemType']),
  itemGroup: getPath('/item-group', ['sidebar.home', 'v2.itemMasterData.index', 'v2.itemMasterData.itemGroup']),

  // User Guide
  userGuide: getPath('/profile/user-guide', ['sidebar.home', 'v2.userGuide.index']),
  userGuideAdd: getPath('/profile/user-guide/add', ['sidebar.home', 'v2.userGuide.index', 'action.add']),

  // QR Scanner
  qrScanner: getPath('/s/qr-scanner', ['v2.sidebar.home', 'v2.sidebar.qrScanner.index'])
};
